// JsFromRoutes CacheKey d73030b9940b255fb736d2ad23715573
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  message: /* #__PURE__ */ definePathHelper('post', '/:account_id/translations/message'),
  text: /* #__PURE__ */ definePathHelper('post', '/:account_id/translations/text'),
  detect: /* #__PURE__ */ definePathHelper('post', '/:account_id/translations/detect'),
  languages: /* #__PURE__ */ definePathHelper('get', '/:account_id/translations/languages'),
}
